import script from "./ElementsAuditLogLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./ElementsAuditLogLoader.vue?vue&type=script&setup=true&lang=js"

import "./ElementsAuditLogLoader.vue?vue&type=style&index=0&id=1385b2ca&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1385b2ca"]])

export default __exports__